import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import CreateComplaint from '../components/complain/CreateComplaint';
import Complain from '../components/complain/Complain';
import ComplainDetails from '../components/complain/ComplainDetails';

const ComplainRoutes = ({ match: { url } }) => 
  <Switch>
    <ProtectedRoute exact path={`${url}`} rols={['manager', 'property']} component={Complain} />
    <ProtectedRoute exact path={`${url}/create`} rols={['property']} component={CreateComplaint} />
    <ProtectedRoute exact path={`${url}/:id`} rols={['manager', 'property']} component={ComplainDetails} />
    <Redirect to="/errors/404" />
  </Switch>

ComplainRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(ComplainRoutes);
